import React, { memo, useCallback, useState } from 'react'

import {
  Button,
  ClosingDropdown,
  Icon,
  ChevronDown,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { isExportInFlightForCurrentView } from 'Pods/ThreeDStudio/Store/slices/export'

import ExportFormatPopover from '../ExportFormatPopover/ExportFormatPopover'
import { EXPORT_FORMAT_LABELS } from '../formatLabels'

const trailIcon = (
  <span className="export-cluster__chevron">
    <Icon svgComponent={ChevronDown} color="dark" size={iconSize} notSpaced />
  </span>
)

function ExportFormatButton() {
  const selectedFormat = useThreeDStudioStore(state => state.export.selectedFormat)
  const isInFlight = useThreeDStudioStore(isExportInFlightForCurrentView)

  const [triggerCloseDropdown, setTriggerCloseDropdown] = useState(false)
  const handleClosePopover = useCallback(() => {
    setTriggerCloseDropdown(true)
  }, [])

  const label = EXPORT_FORMAT_LABELS[selectedFormat] ?? selectedFormat.toUpperCase()

  return (
    <ClosingDropdown
      content={(
        <ExportFormatPopover
          selectedFormat={selectedFormat}
          onClosePopover={handleClosePopover}
        />
      )}
      isSimpleContent
      isDisabled={isInFlight}
      size="medium"
      placement="top-end"
      contentClassName="export-format-popover-wrap"
      className="export-cluster__format-wrap"
      usePortal
      triggerCloseDropdown={triggerCloseDropdown}
      setTriggerCloseDropdown={setTriggerCloseDropdown}
    >
      <Button
        trailIcon={trailIcon}
        type="secondary"
        size="small"
        variant="with-icon"
        aria-label={`Export format (${label})`}
        customClass="export-cluster__format"
        disabled={isInFlight}
      >
        {label}
      </Button>
    </ClosingDropdown>
  )
}

export default memo(ExportFormatButton)
